export enum NotebookView {
  Widget = 'widget',
  Feedback = 'feedback',
}
